import React from 'react'

export default function MapCardNumber({ number, color }) {
  if (!number) return null
  return <div className={`MapCardNumber ${color}`}>{number}</div>
}
